export const SEND_REMINDER = 'GIFTYA/SEND_REMINDER';
export const SEND_REMINDER_RESET = 'GIFTYA/SEND_REMINDER_RESET';
export const SEND_REMINDER_SUCCESS = 'GIFTYA/SEND_REMINDER_SUCCESS';
export const SEND_REMINDER_FAILURE = 'GIFTYA/SEND_REMINDER_FAILURE';
export const FETCH_LINK = 'GIFTYA/FETCH_LINK';
export const FETCH_LINK_SUCCESS = 'GIFTYA/FETCH_LINK_SUCCESS';
export const FETCH_LINK_FAILURE = 'GIFTYA/FETCH_LINK_FAILURE';
export const CREATE_GIFT_REDEMPTION_ACCOUNT_LINK = 'GIFTYA/CREATE_GIFT_REDEMPTION_ACCOUNT_LINK';
export const CREATE_GIFT_REDEMPTION_ACCOUNT_LINK_RESET = 'GIFTYA/CREATE_GIFT_REDEMPTION_ACCOUNT_LINK_RESET';
export const LINK_REDEMPTION_ACCOUNT = 'GIFTYA/LINK_REDEMPTION_ACCOUNT';
export const LINK_REDEMPTION_ACCOUNT_RESET = 'GIFTYA/LINK_REDEMPTION_ACCOUNT_RESET';

export const sendReminder = (data) => ({
    type: SEND_REMINDER,
    data
});
export const sendReminderReset = (data) => ({
    type: SEND_REMINDER_RESET,
    data
});
export const sendReminderSuccess = () => ({
    type: SEND_REMINDER_SUCCESS
});
export const sendReminderFailure = (data) => ({
    type: SEND_REMINDER_FAILURE,
    data
});


export const fetchLink = (data) => ({
    type: FETCH_LINK,
    data
});
export const fetchLinkSuccess = (data) => ({
    type: FETCH_LINK_SUCCESS,
    data
});
export const fetchLinkFailure = (data) => ({
    type: FETCH_LINK_FAILURE,
    data
});




export const linkRedemptionAccount = (payload, meta = {}, error = false) => ({
    type: LINK_REDEMPTION_ACCOUNT,
    payload,
    meta,
    error
});
export const linkRedemptionAccountReset = (payload, meta, error) => ({
    type: LINK_REDEMPTION_ACCOUNT_RESET,
    payload,
    meta,
    error
});